<template>
	<div id="app">
		<!-- <img alt="Vue logo" src="./assets/logo.png"> -->
		<UploadAuth msg="Welcome to Your Vue.js App" />
		<!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
		<!-- <AllImgFile></AllImgFile> -->
		<!-- <UploadAuth msg="Welcome to Your Vue.js App" /> -->
		<!-- <router-view></router-view> -->

	</div>
</template>

<script>
	import HelloWorld from './components/HelloWorld.vue'
	import AllImgFile from './components/AllImgFile.vue'
	import UploadAuth from './components/UploadAuth.vue'

	export default {
		name: 'app',
		components: {
			HelloWorld,
			AllImgFile,
			UploadAuth
		}
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}
</style>